import { WsMessage } from '@numeo/types-core'
import axios from 'axios'

/**
 * Send a message that was previously sent via WebSocket to the HTTP API
 */
export async function sendWebSocketMessage(message: WsMessage) {
    try {
        const response = await axios.post(`/ws-messages`, message, {
            headers: {
                'Content-Type': 'application/json',
            },
            withCredentials: true,
        })

        return response.data
    } catch (error) {
        console.error('Error sending WebSocket message via HTTP:', error)
        throw error
    }
}
